/* eslint-disable no-param-reassign */
(() => {
  const whishListInjector = document.querySelector(".hidden-wishlist-btn .wkh-button");
  const wishListCounters = document.querySelectorAll(".js-wishlist-counter");

  const populateWishlistCounter = () => {
    wishListCounters.forEach((counter) => {
      const countNumber = parseInt(whishListInjector.querySelector(".wkh-counter").innerText, 10);
      const isHeaderWishlistCounter = counter.parentElement.classList.contains("user-links__wishlist-link");
      if (countNumber > 99 && isHeaderWishlistCounter) {
        counter.innerText = "99+";
        return;
      }
      counter.innerText = countNumber;
    });
  };

  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver(() => {
    populateWishlistCounter();
  });

  observer.observe(whishListInjector, observerOptions);
  populateWishlistCounter();
})();
